import React, { useState, useRef } from "react";
import CustomLine from "./CustomLine";
import Process1 from "../../src/assets/images/process1.png";
import Process2 from "../../src/assets/images/process2.png";
import Process3 from "../../src/assets/images/process3.png";
import AppoinmentModal from "./AppoinmnetModal";

const ServiceBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const stickyButtonRef = useRef(null);
    
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="custom-science pt-80 bg-[#f2f0ed]">
            <div className="xl-screen-padding flex gap-10 flex-col md:flex-row w-full">
                <div className="custom-padding w-full md:w-1/2 flex flex-col justify-center aboutmain">
                    <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md md:pt-20 font-lato block sm:flex items-center slide-left">
                        <CustomLine />
                        <span className="ml-0 sm:ml-2 text-p">Nutrillion Service</span>
                    </p>
                    <h2 className="custom-padding-bottom text-lg sm:text-xl custom-line-height md:text-xl lg:text-4xl font-semibold text-black leading-tight client-text">
                        "Harness Your Genetic
                        <br />
                        Potential for Optimal Health"
                    </h2>
                    <p className="text-[#939a9e] mb-6 text-p">
                        Every individual has unique health concerns, and their nutritional needs should reflect that individuality. At Nutrillion, we go beyond conventional nutrition plans by offering a holistic, science-driven approach tailored to your genetic profile and gut health. Our premium programs provide structured, data-backed solutions to help you achieve long-term well-being.                    </p>
                    <p className="text-[#939a9e] mb-6 text-p">
                        <span className="text-[#ca8a04] font-semibold">From Genes to Wellness : </span>
                        A Personalized Nutrition Approach. By decoding your genetic blueprint, we provide unparalleled insights into how your body processes essential nutrients. Our advanced research identifies key genetic markers that influence nutrient absorption, metabolism, and dietary sensitivities.
                    </p>
                    <div className="flex flex-row space-x-3 items-center">
                        <a href="https://wa.me/+919557439399" target="_blank" rel="noopener noreferrer">
                            <button className="bg-gray-800 common-btn-all-second text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto">
                                Get Started
                            </button>
                        </a>
                        <button
                            onClick={openModal}
                            className="bg-[#8f762c] common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto"
                        >
                            Contact Us
                        </button>
                        <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
                    </div>
                </div>

                <div className="w-full md:w-1/2 flex flex-col items-center justify-center">
                    <img src={require("../../src/assets/images/ServicesBanner.png")} alt="Icon" className="" />
                </div>
            </div>
            <div>
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>

                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>

            <section className="mt-20">
                <div
                    className="our-process-section custom-padding xl-screen-padding py-20 pt-80 pb-80"
                    style={{
                        background: 'linear-gradient(to right, #fff1c6, #cccccc, #dac587, #f2fded)',
                        backgroundSize: '200% 200%',
                        animation: 'gradientBackground 15s ease infinite',
                        width: '100%',
                        overflow: 'hidden',
                    }}
                >
                    <div className="text-center mb-12 client-text">
                        <h3 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#7C517E]">
                            Our Process
                        </h3>
                    </div>
                    <div className="flex flex-col sm:flex-row justify-center gap-8 pb-80">
                        <div className="w-full sm:w-1/3 flex flex-col items-center mb-8 sm:mb-0 relative group">
                            <img src={Process1} alt="Step 1" className="w-full h-auto object-cover mb-4 " />
                            <div className="absolute bottom-[-100px] left-0 w-full bg-[#f2f0ed] text-white text-center px-4 py-4 opacity-0 group-hover:opacity-100 group-hover:h-[120px] transition-all duration-300 rounded-b-[15px]">
                                <p className="text-[#6f787e]">We study 12-25 key parameters, including obesity, fitness genomics, nutrigenomics, and chronic illness genomics, to provide deep health insights.</p>
                            </div>
                            <p className="text-center text-white client-text absolute bottom-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded whitespace-nowrap">
                                Comprehensive Genetic Analysis
                            </p>
                        </div>
                        <div className="w-full sm:w-1/3 flex flex-col items-center mb-8 sm:mb-0 relative group">
                            <img src={Process2} alt="Step 2" className="w-full h-auto object-cover mb-4  three-services" />
                            <div className="absolute bottom-[-100px] left-0 w-full bg-[#f2f0ed] text-white text-center px-4 py-4 opacity-0 group-hover:opacity-100 group-hover:h-[120px] transition-all duration-300 rounded-b-[15px]">
                                <p className="text-[#6f787e]">Get a clear understanding of your body's response to alcohol, caffeine, lactose, and gluten.</p>
                            </div>
                            <p className="text-center text-white client-text absolute bottom-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded whitespace-nowrap">
                                Sensitivity & Tolerance Assessment
                            </p>
                        </div>
                        <div className="w-full sm:w-1/3 flex flex-col items-center relative group">
                            <img src={Process3} alt="Step 3" className="w-full h-auto object-cover mb-4  three-services" />
                            <div className="absolute bottom-[-100px] left-0 w-full bg-[#f2f0ed] text-white text-center px-4 py-4 opacity-0 group-hover:opacity-100 group-hover:h-[120px] transition-all duration-300 rounded-b-[15px]">
                                <p className="text-[#6f787e]"> Access a curated food database tailored to your genetic and gut profile for optimal nutrition.</p>
                            </div>
                            <p className="text-center text-white client-text absolute bottom-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded whitespace-nowrap">
                                Personalized Food Insights
                            </p>
                        </div>

                    </div>
                    <div className=" text-center pt-16 pb-16">
                        <p className="text-md sm:text-sm text-[#6f787e] font-semibold client-text">
                            DISCLAIMER: The Nutrigenomics Test is a compulsory component of all our programs, ensuring data-driven and scientifically validated recommendations.
                        </p>
                    </div>
                </div>

            </section>


        </div>
    );
};

export default ServiceBanner;
